export const productNameRequiredMessage = 'Informe um nome para identificar o produto.'

export function validateProductName(value: string): string | undefined {
  return value.trim().length > 0 ? undefined : productNameRequiredMessage
}
